export enum ETranscriptionStatus {
  NOT_READY = "NOT_READY",
  PROCESSING = "PROCESSING",
  READY = "READY"
}